<template>
	<template-base class="containerCard">
		<div>
			<div v-if="taxes.length && !showPaginationOnlyFooter" class="head-row mb-2 width-pagination-items">
				<div class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + taxes.length }} de {{ pagination.count }}
					</label>
					<b-pagination
						class="mr-0 mb-2"
						id="page"
						v-model="currentPage"
						:total-rows="pagination.count"
						:per-page="pagination.limit.value"
					></b-pagination>
				</div>
				<b-form
					class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Itens por página
					</label>
					<b-form-select
						class="mr-0 mb-2"
						v-model="pagination.limit.value"
						name="itens-por-pagina"
						:options="optionsItensPorPag"
						@input="changeItensByPage()"
						:disabled="loading"
					/>
				</b-form>
			</div>
			<b-modal
				ref="modalEdicao"
				hide-footer
				:title="titleModalEdicao"
				size="md"
				no-close-on-backdrop
				hide-header-close
				hide-header
			>
				<div class="title-modal">
					<div class="title-text-modal">{{ titleModalEdicao }}</div>
					<div
						class="float-right btn-hover-modal"
						@click="fecharModal('modalEdicao')"
					>
						<xIcon/>
					</div>
				</div>
				<div class="modal-edicao mb-3 modal-edicao-label mt-6">
					<b-row class="mb-3">
						<b-col class="d-block text-parcela">
							<span class="label-conta">Descrição</span>
							<b-form-input
								name="description-taxe"
								class="modal-edicao-input"
								type="text"
								v-model="taxeSelect.description"
								autocomplete="off"
								placeholder="Digite a descrição"
								v-validate="'required|maxLength:100'"
								:state="validateState('description-taxe')"
							/>
						</b-col>
					</b-row>
					<b-row class="mb-3">
						<b-col class="d-block text-parcela">
							<span class="label-conta">Tributo</span>
							<b-form-input
								name="name-taxe"
								class="modal-edicao-input"
								type="text"
								v-model="taxeSelect.name"
								autocomplete="off"
								placeholder="Digite o nome do tributo"
								v-validate="'required|maxLength:100'"
								:state="validateState('name-taxe')"
							/>
						</b-col>
						<b-col class="d-block text-parcela">
							<span class="label-conta">Alíquota</span>
							<b-form-input
								name="value-taxe"
								class="modal-edicao-input number-class"
								type="text"
								inputmode="numeric"
								v-model="taxeSelect.value"
								autocomplete="off"
								placeholder=""
								v-validate="'required|noZeroCurrency'"
								:state="validateState('value-taxe')"
								@input="updateValue('value')"
								@focus="handleFocus('value')"
								@blur="handleBlur('value')"
							/>
						</b-col>
					</b-row>
					<b-row class="mb-2 mt-4">
						<b-col class="text-parcela border-t border-b p-2 ml-3 mr-3">
							<span class="label-section">
								Dados para agendamento de pagamento
							</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col class="text-parcela">
							<span class="label-conta">
								Conta
							</span>
							<div>
								<b-form-select
									class="modal-edicao-input"
									v-model="taxeSelect.idAccount"
									name="account"
									:options="optionAccount.filter(account => !account.permitePagamento)"
									:disabled="loading"
									:state="validateState('account')"
								>
									<template slot="first">
										<option :value="null">
											Selecione
										</option>
									</template>
								</b-form-select>
							</div>
						</b-col>
						<b-col class="text-parcela">
							<span class="label-conta">
								Categoria
							</span>
							<div>
								<b-form-select
									class="modal-edicao-input"
									v-model="taxeSelect.idCategory"
									name="category"
									:options="optionCategory"
									:disabled="loading"
									:state="validateState('category')"
								>
									<template slot="first">
										<option :value="null">
											Selecione
										</option>
									</template>
								</b-form-select>
							</div>
						</b-col>
						<b-col class="d-block text-parcela mb-2">
							<span class="label-conta">Dia de Pagamento</span>
							<b-form-input
								name="paiment-day"
								class="modal-edicao-input number-class"
								type="number"
								min="1"
								max="31"
								v-model="taxeSelect.paymentDay"
								autocomplete="off"
								placeholder=""
								v-validate="{ required: false, min_value: 1, max_value: 31 }"
								:state="validateState('paiment-day')"
							/>
						</b-col>
					</b-row>
				</div>
				<b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="fecharModal('modalEdicao')">Cancelar</b-button>
				<b-button class="mt-3 float-left btn-modal btn-limpar" @click="limparModal()">Limpar</b-button>
				<b-button
					class="mt-3 ml-1 float-right btn-modal btn-salvar"
					@click="salvarEdicao"
					:disabled="invalidForm || saving"
				>
					Salvar
				</b-button>
			</b-modal>
		</div>
		<div>
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nofilters="true"
				name="taxes"
				:hasPagination="true"
				:noedit="true"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_TRIBUTO')"
				:permissaoDelete="possuiPermissao('GER_D_TRIBUTO')"
				@clickDelete="confirmaApagar"
				@clickEdit="mostrarEdicao"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				:alignColumns="alignColumnsTable"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="mostrarEdicao"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_TRIBUTO')"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_TRIBUTO')"
				:permissaoDelete="possuiPermissao('GER_D_TRIBUTO')"
				@clickDelete="confirmaApagar"
				@clickEdit="mostrarEdicao"
				:selectItem="false"
				:globalAcoes="false"
				:colsDataCard="colsDataCard"
				:details="false"
				:showSelectItem="false"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="mostrarEdicao"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_TRIBUTO')"
			/>
		</div>
		<div v-if="taxes.length && showPaginationOnlyFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
	</template-base>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";

	import { possuiPermissao } from "../../helpers/permissions";
	import { TaxeService } from "../../services/taxe";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import CardTransaction from "@/components/CardTransaction.vue";
	import { numberFormatted, stringToNumber, validateNumber, isNullValue } from "@/helpers/common";
	import { AccountService } from "../../services/account";
	import { CategoryExpensesService } from "../../services/categoryExpenses";

	export default {
		components: {
			TemplateBase,
			DataTable,
			CardTransaction
		},

		inject: ["parentValidator"],

		data () {
			return {
				taxes: [],
				linhas: [],
				titleModalEdicao: "",
				loading: true,
				taxeSelect: {
					idTaxe: "",
					name: "",
					description: "",
					value: "0,00",
					idAccount: null,
					idCategory: null,
					paymentDay: 1
				},

				optionAccount: [],
				optionCategory: [],

				invalidForm: true,
				taxeService: new TaxeService(),
				accountService: new AccountService(),
				categoryService: new CategoryExpensesService(),

				errMsg: "Nenhum tributo cadastrado!",
				colunas: [
					"Descrição",
					"Tributo",
					"Alíquota"
				],
				alignColumnsTable: [
					"left",
					"left",
					"right"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 50
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				sortTable: {
					sortBy: 0,
					order: 1,
					query: ""
				},
				isMobile: false,
				colsDataCard: {
					0: {
						idx: 0,
						label: "Descrição",
						textAlign: "left",
						cols: 12,
						visible: true
					},
					1: {
						idx: null,
						label: "",
						textAlign: "left",
						cols: 6,
						visible: false
					},
					2: {
						idx: 1,
						label: "Tributo",
						textAlign: "left",
						cols: 8,
						visible: true
					},
					3: {
						idx: 2,
						label: "Alíquota",
						textAlign: "right",
						cols: 4,
						visible: true
					},
					4: {
						idx: null,
						label: "",
						textAlign: "center",
						cols: 4,
						visible: false
					},
					5: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					},
					6: {
						idx: null,
						label: "",
						textAlign: "center",
						cols: 6,
						visible: false
					},
					7: {
						idx: null,
						label: "",
						textAlign: "center",
						cols: 6,
						visible: false
					}
				},
				saving: false,
				showPaginationOnlyFooter: true
			};
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		created () {
			this.$validator = this.parentValidator;
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			await Promise.all([
				this.findAccount(),
				this.findCategory(),
				this.findTaxes()
			]);
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			async findCategory () {
				const result = await this.categoryService.listCategoryExpenses({offset: 0, limit: null}) || {};
				this.optionCategory = result.rows?.reduce((acc, item) => {
					acc.push({ text: item.description, value: item.idCategoryExpense });

					return acc;
				}, []);
			},

			async findAccount () {
				const result = await this.accountService.listAccount({offset: 0, limit: null}) || {};
				this.optionAccount = result.rows?.map(item => ({
					text: item.description,
					value: item.idAccount,
					permitePagamento: item.accountClass.automaticPay,
					balance: item.balance || "0,00"
				})) || [];
			},

			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findTaxes();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findTaxes();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findTaxes();
			},

			async findTaxes () {
				this.loading = true;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				const result = await this.taxeService.listTaxe({offset, limit, sortTable}) || {};
				this.taxes = result.rows || [];

				this.linhas = result.rows.reduce((acc, c) => [
					...acc,
					{
						idTaxe: c.idTaxe,
						cols: [
							c.description,
							c.name,
							numberFormatted(c.value)
						]
					}
				], []);

				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			async mostrarEdicao (item_) {
				let item = {};
				if (item_.idTaxe)
					[ item ] = this.taxes.filter(c => c.idTaxe === item_.idTaxe);

				const { idTaxe, name, description, value, idAccount, idCategoryExpense, paymentDay } = item;

				if (!idTaxe)
					this.titleModalEdicao = "Cadastrar Novo Tributo";
				else
					this.titleModalEdicao = "Editar Tributo";

				this.invalidForm = true;
				this.taxeSelect.idTaxe = idTaxe || "";
				this.taxeSelect.name = name || "";
				this.taxeSelect.description = description || "";
				this.taxeSelect.value = value ? numberFormatted(value) : "0,00";
				this.taxeSelect.idAccount = idAccount;
				this.taxeSelect.idCategory = idCategoryExpense;
				this.taxeSelect.paymentDay = paymentDay;

				this.$refs.modalEdicao.show();
			},

			async confirmaApagar (item_) {
				const [ item ] = this.taxes.filter((gu) => gu.idTaxe === item_.idTaxe);
				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja remover o tributo?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.apagar(item.idTaxe);
			},

			async salvarEdicao () {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};
				const payload = {
					idTaxe: this.taxeSelect.idTaxe,
					name: this.taxeSelect.name,
					description: this.taxeSelect.description,
					value: stringToNumber(this.taxeSelect.value),
					idAccount: this.taxeSelect.idAccount,
					idCategoryExpense: this.taxeSelect.idCategory,
					paymentDay: this.taxeSelect.paymentDay
				};

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						await this.taxeService.upsertTaxe({payload});

						this.fecharModal("modalEdicao");
						this.limparModal();
						this.findTaxes();

						return {
							title: "Sucesso!",
							body: "Conta salva com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar conta!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			fecharModal (modal) {
				this.$refs[modal].hide();
			},

			async apagar (idTaxe) {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						await this.taxeService.deleteTaxe({idTaxe});
						this.findTaxes();

						return {
							title: "Sucesso!",
							body: "Tributo deletado com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar tributo!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			limparModal () {
				this.idTaxe = null;
				this.taxeSelect.name = "";
				this.taxeSelect.description = "";
				this.taxeSelect.value = "0,00";
				this.taxeSelect.idAccount = null;
				this.taxeSelect.idCategory = null;
				this.taxeSelect.paymentDay = 1;
				this.invalidForm = true;
				this.saving = false;
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			async updateValue (key) {
				const value = this.taxeSelect[key];
				this.taxeSelect[key] = await validateNumber(value);
			},

			handleFocus (key) {
				if (isNullValue(this.taxeSelect[key]))
					this.taxeSelect[key] = "";
				else
					this.taxeSelect[key] = this.taxeSelect[key].toString().replace(".", "");
			},

			handleBlur (key) {
				if (!this.taxeSelect[key]) {
					this.taxeSelect[key] = "0,00";
				} else {
					this.taxeSelect[key] = numberFormatted(stringToNumber(this.taxeSelect[key]));
				}
			},

			newSearch (state) {
				this.sortTable.query = state.query;
				this.findTaxes();
			}
		}
	};
</script>

<style scoped>
	.label-section {
		color: #252525 !important;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin-bottom: 0px;
	}

	.toggle-conta {
		/* display: flex; */
		margin-top: 7px;
		/* justify-content: center; */
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 5rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.modal-edicao-label {
		font-family: 'Roboto Condensed Regular';
		font-size: 23px;
	}

	.modal-edicao-input {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.container-add-new-100 {
		width: 100% !important;
	}
</style>
